import { Form, Input, Tooltip } from 'antd';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { PlusButton } from 'src/components/common/PlusButton/PlusButton';
import { SearchPanel } from 'src/components/SearchPanel/SearchPanel';
import {
    SearchPanelFilterForm,
    SearchPanelFilterFormProps,
} from 'src/components/SearchPanel/SearchPanelFilterForm';
import { EntityLinks } from 'src/core/router/EntityLinks';
import { Router } from 'src/core/router/Router';
import { AgentsFilter, AgentsStore } from 'src/stores/AgentsStore/AgentsStore';
import { UserStore } from 'src/stores/UserStore/UserStore';
import { FormHelper } from 'src/utils/FormHelper';
import styled from 'styled-components';

export const AgentsPageHeaderPanel = observer(() => {
    const { t } = useTranslation();

    return (
        <StyledHeaderWrapper>
            <SearchPanel
                inputSearchFormName={formNames.getPath('filterSearch')}
                store={store}
                renderPanel={(props) => <FilterPanel {...props} />}
                inputSearchPlaceholder={t(
                    'Page.Agents.Filter.Search.Placeholder',
                )}
            />
            {UserStore.can.manage.agents && (
                <Tooltip
                    title={t('Page.Agents.AsideHeader.CreateNewItem.Tooltip')}
                >
                    <PlusButton
                        onClick={() => {
                            const createLink = EntityLinks.agents.create?.();
                            createLink && Router.navigate(createLink);
                        }}
                        data-testid="header-panel-create-btn"
                    />
                </Tooltip>
            )}
        </StyledHeaderWrapper>
    );
});

const StyledHeaderWrapper = styled.header`
    position: relative;
    display: grid;
    grid-template-columns: 1fr auto;
`;

export const FilterPanel = observer((props: SearchPanelFilterFormProps) => {
    const { t } = useTranslation();

    return (
        <SearchPanelFilterForm
            {...props}
            onFinish={({ ...values }: AgentsFilter) => {
                store.filterCriteria?.applyFilter({
                    ...values,
                });
                store.loadList();
            }}
        >
            <Form.Item
                label={t('Page.Agents.Filter.TaxId')}
                name={formNames.getPath('filterTaxNumber')}
            >
                <StyledInput type="string" data-testid="taxId" />
            </Form.Item>
        </SearchPanelFilterForm>
    );
});

const store = AgentsStore;
const formNames = FormHelper.createNameProvider<AgentsFilter>();

const StyledInput = styled(Input)`
    height: 2.7rem;
    border-radius: 0.5rem;
`;
